import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class CardReplacementOrder extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {
		} = this.props;

		const url = new URL(window.location.href);
		let searchParamsUrl = url.searchParams;
		searchParamsUrl.set('formId', this.getFormId());
		url.search = searchParamsUrl.toString();
		const newUrl = url.toString();
		window.history.pushState("", "", newUrl);
	}

	/**
	 *	Získání formId z formuláře
	 */
	getFormId = () => {
		return document.querySelector('form input[name=formId]').value;
	};
}

export default CardReplacementOrder;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/CardReplacementOrder.js